<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div>
      {{language=='es'?"Español":'中文'}}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="language==='zh'" command="zh">中文</el-dropdown-item>
      <!-- <el-dropdown-item :disabled="language==='en'" command="en">English</el-dropdown-item> -->
       <el-dropdown-item :disabled="language==='es'" command="es">
        Español
      </el-dropdown-item>
     <!-- <el-dropdown-item :disabled="language==='ja'" command="ja">
        日本語
      </el-dropdown-item>-->
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { setLanguage,getLanguage } from "@/utils/storage.js";
import Cookies from 'js-cookie'
export default {
  computed: {
    language() {
      var language=getLanguage()
      Cookies.set('language',language)
      return language;
    }
  },
  methods: {
    handleSetLanguage(lang) {
          this.$router.go(0);
          this.$i18n.locale = lang;
          // if (lang == "es") {
          //   setLanguage("en_US");
          // } else {
           
          // }
          Cookies.set('language',lang)
          setLanguage(Cookies.get('language'))
       
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/LangSelect/index.vue